export default "__VITE_ASSET__B0D$TEn5__"